import React, { useEffect, useState } from "react";
import { Modal, Form, Input, Button, message } from "antd";
import axios from "axios";
import { RegisterationUrl } from "../urls";
import { useDispatch } from "react-redux";
import { __hideLoader, __showLoader } from "../Redux Store/Slices/loader";
import setHash, { removeHash } from "../set-hash";
import CustomModal from "./CustomModal";
import { tempToast } from "../utils/toasts";

const RequestCallback = ({ open = false, buttonComp = null }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    useEffect(() => {
        setIsModalOpen(open)
    }, [open]);
    const [form] = Form.useForm();
    const dispatch = useDispatch();


    const showModal = () => {
        tempToast();
        // setIsModalOpen(true);
        // setHash("request-callback")
    };

    const handleOk = () => {
        dispatch(__showLoader('Requesting Callback...'));
        form
            .validateFields()
            .then(async (values) => {
                const data = {
                    name: values.name,
                    phoneNumber: values.phone,
                    companyType: 'PRONTTERA_LABS'
                }
                try {
                    // Replace `your-api-endpoint` with the actual API endpoint
                    const response = await axios.post(RegisterationUrl.requestCallback, data);
                    console.log("Response:", response.data);
                    message.success("Callback requested successfully!");
                    setIsModalOpen(false);
                    form.resetFields(); // Reset the form after submission
                } catch (error) {
                    console.error("Error:", error);
                    message.error("Failed to request callback. Please try again.");
                }
            })
            .catch((info) => {
                console.error("Validation Failed:", info);
            }).finally(() => {
                dispatch(__hideLoader());
            })
    };

    const handleCancel = () => {
        setIsModalOpen(false);
        removeHash();
        form.resetFields(); // Reset the form on cancel
    };

    return (
        <div>

            <div className="" onClick={showModal}>
                {buttonComp}
            </div>
            {<Modal
                title="Request a Callback"
                open={isModalOpen}
                onOk={handleOk}
                onCancel={handleCancel}
                okText="Submit"
                cancelText="Cancel"
            >
                <Form
                    form={form}
                    layout="vertical"
                    name="request_callback"
                >
                    <Form.Item
                        label="Name"
                        name="name"
                        rules={[
                            { required: true, message: "Please enter your name" },
                            { min: 2, message: "Name must be at least 2 characters" },
                        ]}
                    >
                        <Input placeholder="Enter your name" />
                    </Form.Item>

                    <Form.Item
                        label="Phone Number"
                        name="phone"
                        rules={[
                            { required: true, message: "Please enter your phone number" },
                            {
                                pattern: /^\+?[1-9]\d{1,14}$/,
                                message: "Please enter a valid phone number (e.g., +1234567890)",
                            },
                        ]}
                    >
                        <Input placeholder="Enter your phone number with country code" />
                    </Form.Item>
                </Form>
            </Modal>}
        </div>
    );
};

export default RequestCallback;
